import { useMutation, useQueryClient } from "@tanstack/react-query";

import { type CreateStageInput, createStage } from "@/adapters/api";
import { invalidateStageTree } from "../utils/query-keys.ts";
import { useStagesLockedGuard } from "./use-stages-locked-guard.ts";

export function useCreateStage(constructionId: string | undefined) {
	const queryClient = useQueryClient();
	const guardLocked = useStagesLockedGuard(constructionId);

	return useMutation({
		mutationFn: (input: CreateStageInput) => {
			if (!constructionId) throw new Error("missing construction");
			return createStage(constructionId, input);
		},
		onSuccess: () => invalidateStageTree(queryClient, constructionId),
		onError: guardLocked,
	});
}
